export enum FrequencyOfUse {
	SINGLE_USE = 'SINGLE_USE',
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
	YEARLY = 'YEARLY',
	UNSPECIFIED = 'UNSPECIFIED',
}
